import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/hooks/useTheme";
import { Wizard } from "@/screens/Wizard";
import appConfig from "@/config/app.config.json";

const VALID_PALETTES = ["mono", "brand"];

function App() {
  // Set the palette attribute on <html> from app.config.json
  useEffect(() => {
    const requested = appConfig?.theme?.palette;
    const palette = VALID_PALETTES.includes(requested) ? requested : "mono";
    document.documentElement.setAttribute("data-palette", palette);
  }, []);

  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Wizard />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
